/* eslint-disable @typescript-eslint/no-misused-promises */
import Column from "components/general.compoenents/column.component/column.component";
import FilledButton from "components/input.components/filled.button.component/filled.button.component";
import OutlinedTextInput from "components/input.components/outlined.text.input.component/outlined.text.input.component";
import Headline from "components/text.components/headline.component/headline.component";
import { RunningText } from "components/text.components/running.text.component/running.text.component";
import { inject, observer } from "mobx-react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { SignInCredentials } from "services/httpClients/http.auth.client";
import UserStore from "stores/user.store";
import "./auth.form.component.scss";
import GoogleAuth from "../google.auth.component/google.auth.component";
import { yupResolver } from "@hookform/resolvers/yup";
import { authenticationSchema } from "schemas/authentication.schema";
import Center from "components/general.compoenents/center.component/center.component";
import Spacer from "components/general.compoenents/spacer.component/spacer.component";

interface AuthFormProps {
  title?: string;
  subTitle?: string;
  userStore?: UserStore;
  prefillEmail?: string;
}

const AuthForm = ({
  title,
  subTitle,
  userStore,
  prefillEmail,
}: AuthFormProps): JSX.Element => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(authenticationSchema),
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: {
      email: prefillEmail,
      password: "",
    },
  });

  const handleSignIn = async (data: any): Promise<void> => {
    setIsLoading(true);

    const credentials: SignInCredentials = { ...data, kind: "INTERNAL" };

    const user = await userStore?.signIn(credentials);

    setIsLoading(false);

    if (user != null) {
      navigate("/");
    }
  };

  return (
    <div className="sign-in-form-container">
      <div className="sign-in-form-wrapper">
        <Headline>{title ?? "Willkommen zurück!"}</Headline>
        <RunningText className="mb-20">
          {subTitle ?? "Bitte melde dich an, um fortzufahren."}
        </RunningText>

        <form
          className="sign-in-form mt-20"
          onSubmit={handleSubmit(handleSignIn)}
        >
          <OutlinedTextInput
            type="email"
            placeholder="Email"
            initialValue={prefillEmail ?? ""}
            inputRef={register("email")}
            validationMessage={errors.email?.message?.toString()}
          />
          <OutlinedTextInput
            className="mt-15"
            type="password"
            placeholder="Passwort"
            inputRef={register("password")}
            validationMessage={errors.password?.message?.toString()}
          />
          <FilledButton
            isLoading={isLoading}
            color="primary"
            type="submit"
            label="Anmelden"
            className="mt-15 mb-15 full-width"
          />

          <Center className="mb-15">
            <Spacer width="90%" />
          </Center>

          <Center className="mb-15 mt-15">
            <GoogleAuth />
          </Center>
          <div className="additional-actions">
            <Column alignItems="center">
              {/* <RunningText navLink="/sign-up" className="mt-10">
                Kein Account? Melde dich kostenlos an.
              </RunningText> */}
              <RunningText navLink="/forgot-password" className="mt-5 ml-10">
                Passwort vergessen?
              </RunningText>
            </Column>
          </div>
        </form>
      </div>
    </div>
  );
};

export default inject("userStore")(observer(AuthForm));
